/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Box_DimensionsInputs */

const en_inbound_field_box_dimensions = /** @type {(inputs: Inbound_Field_Box_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box dimensions`)
};

/**
* | output |
* | --- |
* | "Box dimensions" |
*
* @param {Inbound_Field_Box_DimensionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_box_dimensions = /** @type {((inputs?: Inbound_Field_Box_DimensionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Box_DimensionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_box_dimensions(inputs)
});